export const path = {
  notifications: {
    route: "/notifications",
    link: () => path.notifications.route,
  },
};
